'use client';
import type { FC } from 'react';
import { usePathname } from 'next/navigation';
import { Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { useGetLastContent } from '@/modules/Entertainment/http/client/useGetLastContent';
import { RecentContentCard } from './RecentContentCard';

export const RecentContentWidget: FC<RecentContentWidgetProps> = ({
  title,
}) => {
  const pathname = usePathname();
  const t = useT();

  const { data: lastContent = [], isLoading } = useGetLastContent();

  if (lastContent.length === 0) return <></>;

  if (isLoading) {
    return (
      <WidgetContainer
        containerId="recentContent"
        title={title}
        buttonLink={PATHS.hubs.research}
      >
        {Array.from({ length: 10 }).map((_, idx) => (
          <Skeleton
            key={idx}
            w="21.25rem"
            maxW="21.25rem"
            h="32.5rem"
            borderRadius="8px"
          />
        ))}
      </WidgetContainer>
    );
  }

  return (
    <WidgetContainer
      containerId="recentContent"
      title={title ?? t('widgets.RecentContentWidget.title')}
      buttonLink={PATHS.hubs.research}
      removeSeeAllButton={pathname === PATHS.hubs.research}
    >
      {lastContent.map(
        ({
          id,
          published_at,
          thumb,
          title,
          program_title,
          author_name,
          summary,
          bookmarked,
          has_recommendation,
          slug,
          object,
          program_type,
          content_count,
        }) => (
          <RecentContentCard
            key={id}
            id={id}
            slug={slug}
            thumb={thumb}
            authorName={author_name}
            programTitle={program_title}
            publishedAt={published_at}
            summary={summary}
            title={title}
            hasRecommendation={has_recommendation}
            isSaved={bookmarked}
            t={t}
            object={object}
            program_type={program_type}
            content_count={content_count}
          />
        )
      )}
    </WidgetContainer>
  );
};

type RecentContentWidgetProps = {
  title?: string;
};
